"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  created() {
    const {
      params,
      query
    } = this.$route;
    const {
      path
    } = params;
    this.$router.replace({
      path: '/' + path,
      query
    });
  },
  render: function (h) {
    return h(); // avoid warning message
  }
};